import React from 'react'
import Layout from 'common/components/Layout'
import MessagesChart from 'messages/components/MessagesChart'

function Messages() {
  return (
    <Layout>
      <MessagesChart />
    </Layout>
  )
}

export default Messages
